/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';

import {TranslateModule} from '@ngx-translate/core';

import {AccountingModule} from './accounting/accounting.module';
import {AggregatesModule} from './aggregates/aggregates.module';
import {ApiModule} from './api/api.module';
import {AuthenticationModule} from './authentication/authentication.module';
import {ChangeTrackingModule} from './change-tracking/change-tracking.module';
import {ChartsModule} from './charts/charts.module';
import {DocumentsModule} from './documents/documents.module';
import {EmployeesSharedModule} from './employees/employees-shared.module';
import {FilesModule} from './files/files.module';
import {FormGeneratorModule} from './form-generator/form-generator.module';
import {Validators} from './forms';
import {GenerateDocumentModule} from './generate-document/generate-document.module';
import {LegalReportsModule} from './legal-reports/legal-reports.module';
import {loadBsLocales} from './localization/bs-localization';
import {LocalizationModule} from './localization/localization.module';
import {ModalModule} from './modal/modal.module';
import {PayrollSerieListModule} from './payroll-serie-list/payroll-serie-list.module';
import {PipesModule} from './pipes/pipes.module';
import {CreatePopulationComponent} from './population/create-population/create-population.component';
import {CreatePopulationService} from './population/create-population/create-population.service';
import {
  PopulationEntityFieldComponent
} from './population/create-population/population-entity-field/population-entity-field.component';
import {DeleteEntityModalComponent} from './population/delete-entity-modal/delete-entity-modal.component';
import {TeamsSharedModule} from './teams/teams-shared.module';
import {ToastMessageComponent} from './toast/toast-message.component';
import {TreeDiagramModule} from './tree-diagram/tree-diagram.module';
import {UiModule} from './ui/ui.module';
import {UserModule} from './user/user.module';
import {WorkflowV2Module} from './workflow/workflow-v2.module';

import {MomentModule} from 'ngx-moment';
import {DatepickerModule} from './ui/legacy-datepicker';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {ModalModule as BootstrapModalModule} from 'ngx-bootstrap/modal';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {TooltipConfig} from 'ngx-bootstrap/tooltip';
import {ToastrModule} from 'ngx-toastr';
import {ESSModule} from '../+ess/ess.module';
import {MSSModule} from '../+mss/mss.module';
import {MODALS} from '../app.modals';
import {MeModule} from '../me/me.module';
import {NavigationModule} from '../navigation/navigation.module';

loadBsLocales();


@NgModule({
  imports: [
    CommonModule,
    AuthenticationModule.forRoot(),
    LocalizationModule.forRoot(),
    PipesModule,
    UserModule.forRoot(),
    ESSModule.forRoot(),
    MSSModule.forRoot(),
    MeModule,
    BsDatepickerModule.forRoot(),
    UiModule,
    ChartsModule.forRoot(),
    FilesModule,
    ApiModule,
    TabsModule.forRoot(),
    DatepickerModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      toastComponent: ToastMessageComponent
    }),
    ModalModule.forRoot(MODALS),
    BootstrapModalModule,
    NavigationModule,
    MomentModule,
    EmployeesSharedModule.forRoot(),
    TeamsSharedModule.forRoot(),
    ChangeTrackingModule.forRoot(),
    TreeDiagramModule.forRoot(),
    FormGeneratorModule.forRoot(),
    AggregatesModule.forRoot(),
    DocumentsModule.forRoot(),
    GenerateDocumentModule,
    PayrollSerieListModule,
    LegalReportsModule,
    TranslateModule,
    ReactiveFormsModule,
    WorkflowV2Module
  ],
  declarations: [CreatePopulationComponent, PopulationEntityFieldComponent, DeleteEntityModalComponent, ToastMessageComponent],
  exports: [
    AuthenticationModule,
    LocalizationModule,
    PipesModule,
    UserModule,
    ModalModule,
    UiModule,
    ChartsModule,
    FilesModule,
    NavigationModule,
    EmployeesSharedModule,
    TeamsSharedModule,
    ChangeTrackingModule,
    TreeDiagramModule,
    FormGeneratorModule,
    AggregatesModule,
    AccountingModule,
    PayrollSerieListModule,
    TranslateModule,
    CreatePopulationComponent,
    PopulationEntityFieldComponent,
    WorkflowV2Module,
    DeleteEntityModalComponent
  ],
  providers: [
    CreatePopulationService,
    Validators,
    {
      provide: TooltipConfig, useFactory: () => {
        const tooltip = new TooltipConfig();
        tooltip.container = 'body';
        return tooltip;
      }
    }
  ]
})
export class SharedModule {
}
